export default __webpack_public_path__ + "static/media/green-check.0bc3d148.png";